import { FormattedMessage } from 'react-intl';
import MaintenanceState from '@rio-cloud/rio-uikit/lib/es/MaintenanceState';

const SystemMaintenanceState = () => (
    <div className="display-flex align-items-center justify-content-center height-100pct width-100pct margin-y-20">
        <MaintenanceState
            headline={<FormattedMessage id="intl-msg:fleetstatus.systemMaintenance.page.headline" />}
            message={<FormattedMessage id="intl-msg:fleetstatus.systemMaintenance.page.message" />}
        />
    </div>
);

export default SystemMaintenanceState;
